import axios from '@/utils/request'

export function getList(params) {
  return axios.get('/admin_api/v1/app/interactive/', {
    params
  })
}

export function getDetail(uuid) {
  return axios.get(`/admin_api/v1/app/interactive/${uuid}/`)
}

export function add(data) {
  return axios.post('/admin_api/v1/app/interactive/', data)
}

export function edit(uuid, data) {
  return axios.put(`/admin_api/v1/app/interactive/${uuid}/`, data)
}

export function toggle(uuid, params) {
  return axios.put(`/admin_api/v1/app/interactive/${uuid}/enable/`, params)
}

export function questions() {
  return axios.get(`/admin_api/v1/app/interactive/questions/`)
}

export const uploadApi = '/admin_api/v1/main_station/upload/video/'
